import { render, staticRenderFns } from "./DikidiInit.vue?vue&type=template&id=0c0d751c&scoped=true"
import script from "./DikidiInit.vue?vue&type=script&lang=ts"
export * from "./DikidiInit.vue?vue&type=script&lang=ts"
import style0 from "./DikidiInit.vue?vue&type=style&index=0&id=0c0d751c&prod&lang=sass&scoped=true"
import style1 from "./DikidiInit.vue?vue&type=style&index=1&id=0c0d751c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0d751c",
  null
  
)

export default component.exports